import { useGame } from "@/context/GameContext";
import { ITEM_ICON, itemName, SKILL_LABEL } from "@/lib/gameData";

function FeedRow({ item }) {
  const { content } = useGame();
  if (item.kind === "drop") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body">
        <span className="text-lg">{ITEM_ICON[item.item] || "•"}</span>
        <span className="text-emerald-300">+{item.qty}</span>
        <span className="text-stone-200">{itemName(item.item, content?.items)}</span>
      </div>
    );
  }
  if (item.kind === "loot") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body">
        <span className="text-lg">{ITEM_ICON[item.item] || "•"}</span>
        <span className="text-amber-300">+{item.qty}</span>
        <span className="text-amber-100">{itemName(item.item, content?.items)}</span>
        <span className="text-stone-500 text-xs">loot</span>
      </div>
    );
  }
  if (item.kind === "levelup") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body">
        <span>⭐</span>
        <span className="text-yellow-300">Level up!</span>
        <span className="text-stone-200">{SKILL_LABEL[item.skill]}</span>
        <span className="text-stone-500 font-numeric">{item.from}→{item.to}</span>
      </div>
    );
  }
  if (item.kind === "kill") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body">
        <span>🗡</span>
        <span className="text-red-400">Killed</span>
        <span className="text-stone-200">{item.name}</span>
      </div>
    );
  }
  if (item.kind === "pet_unlock") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-amber-200">
        <span>🐾</span>
        <span>You have a funny feeling like you&apos;re being followed…</span>
        <span className="text-amber-400 font-numeric">{item.name}</span>
      </div>
    );
  }
  if (item.kind === "achievement") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-emerald-300">
        <span>🏅</span>
        <span>Achievement:</span>
        <span className="text-emerald-100 font-numeric">{item.name}</span>
        {item.reward_gold ? <span className="text-amber-400 font-numeric">+{item.reward_gold} gp</span> : null}
      </div>
    );
  }
  if (item.kind === "slayer_progress") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-amber-300">
        <span>📜</span> Slayer task progress: {item.initial - item.remaining}/{item.initial}
      </div>
    );
  }
  if (item.kind === "slayer_task_complete") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-amber-200 font-numeric">
        <span>🏆</span> Task complete! +{item.bonus_xp} Slayer XP
      </div>
    );
  }
  if (item.kind === "out_of_runes") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-red-400">
        <span>🪄</span> Out of runes — combat stopped.
      </div>
    );
  }
  if (item.kind === "burn") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-stone-500">
        <span>🔥</span> You burnt the food.
      </div>
    );
  }
  if (item.kind === "death") {
    return (
      <div className="drop-feed-item flex items-center gap-2 text-sm font-body text-red-400">
        <span>💀</span> You were defeated. Reviving…
      </div>
    );
  }
  return null;
}

export function DropFeed() {
  const { feed } = useGame();
  return (
    <div
      className="panel px-4 py-2 h-16 flex items-center gap-6 overflow-x-auto scroll-thin"
      data-testid="drop-feed"
      style={{ borderRadius: 0, borderLeft: "none", borderRight: "none", borderBottom: "none" }}
    >
      <div className="uppercase tracking-widest text-[10px] text-amber-700 font-numeric flex-shrink-0">
        Adventure log
      </div>
      {feed.length === 0 && (
        <div className="text-stone-600 font-body italic text-sm">
          Nothing has happened yet. Pick an action to begin.
        </div>
      )}
      <div className="flex items-center gap-6 flex-nowrap">
        {feed.map((f) => (
          <div key={f._id} className="flex-shrink-0">
            <FeedRow item={f} />
          </div>
        ))}
      </div>
    </div>
  );
}
